/*eslint-disable*/
import { useState, useEffect } from "react";
import client from "../../common/api";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Google from '../../../assets/images/google.svg';
import Facebook from '../../../assets/images/facebook.svg';

import { faEnvelope, faUser } from '@fortawesome/free-solid-svg-icons';

import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input, Form,
    Alert,
} from "reactstrap";
import './roadmap.public.scss';
import Toaster from "../../common/toaster/Toaster";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AuthModal = ({
    publicAuthModal,
    authModalToggle,
    openLoginModal,
    openSignupModal,
    openOverviewModal,
    payloadValid,
    authPayload,
    setauthPayload,
    submitAuthManual,
    guestUserHandler,
    billingDetails,
}) => {
    const {
        type,   // login, signup, overview.
        show,
        overviewType,
        callbackId,
    } = publicAuthModal;
    const hostUrl = window.location.host;

    const googleAuth = () => {
        const companyID = window.location.host.split('.')[0];
        const _hostUrl = hostUrl.replace("www.", "");
        window.open(`${BASE_URL}auth/google/${overviewType}?d=${companyID}`, "_blank");
    };

    // this function caters both login/signup, from google.
    const getSocialLogins = () => {
        return (
            <div className="modal_auth_overview">
                <div className="__border" onClick={() => googleAuth()}>
                    <img
                        src={Google}
                        className="google-auth"
                        alt="google"
                    />
                    <span className="auth-text">
                        Continue with Google
                    </span>
                </div>

                {/* <img src={Facebook} className="facebook-auth __border" alt="facebook" /> */}
                {/* <span className="_separator">&nbsp; </span> */}

                <div className="__border" onClick={() => overviewType === 'login' ? openLoginModal() : openSignupModal()}>
                    <FontAwesomeIcon
                        className="email-auth"
                        icon={faEnvelope}
                    />
                    <span className="auth-text">
                        Continue with Email
                    </span>
                </div>
            </div>
        )
    };

    const getModalHeader = () => {
        if (type === 'login' || (type === 'overview' && overviewType === 'login')) {
            return (
                <p style={{ marginBottom: '0' }}>Login</p>
            )
        }
        else if (type === 'signup' || (type === 'overview' && overviewType === 'signup')) {
            return (
                <p style={{ marginBottom: '0' }}>Create account</p>
            )
        }
    }

    const show_guest_post = billingDetails?.details.plan !== 'free' && billingDetails?.guest_posting_enabled;

    return (
        <>
            <Modal
                isOpen={show}
                toggle={authModalToggle}
                className="modal-dialog-centered"
            >
                <ModalHeader toggle={authModalToggle}>
                    {getModalHeader()}
                </ModalHeader>
                <ModalBody className={` ${type === 'overview' && '_no-padding'}`}>

                    {
                        type === 'overview' ? (
                            <>
                                {getSocialLogins()}
                            </>

                        ) : (
                            <Form>
                                {
                                    type === 'signup' && (
                                        <FormGroup>
                                            <Label for="exampleEmail">
                                                Full Name *
                                            </Label>
                                            <Input
                                                id="exampleEmail"
                                                className="title-input"
                                                name="email"
                                                placeholder="enter your full name"
                                                type="email"
                                                style={{ color: '#000' }}
                                                value={authPayload.name}
                                                onChange={(e) => setauthPayload({ ...authPayload, name: e.target.value })}
                                            />
                                        </FormGroup>
                                    )
                                }
                                <FormGroup>
                                    <Label for="exampleEmail">
                                        Email *
                                    </Label>
                                    <Input
                                        id="exampleEmail"
                                        className="title-input"
                                        name="email"
                                        placeholder="enter your email"
                                        type="email"
                                        style={{ color: '#000' }}
                                        value={authPayload.email}
                                        onChange={(e) => setauthPayload({ ...authPayload, email: e.target.value })}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleEmail">
                                        Password *
                                    </Label>
                                    <Input
                                        id="exampleEmail"
                                        name="email"
                                        className="title-description"
                                        placeholder="enter your password"
                                        type="text"
                                        style={{ color: '#000' }}
                                        value={authPayload.description}
                                        onChange={(e) => setauthPayload({ ...authPayload, password: e.target.value })}
                                    />
                                </FormGroup>
                                <p style={{ fontSize: '10px', marginBottom: '0' }}>By clicking on "Save" you agree to our <a target="_blank" href="https://productlogz.com/privacy"><span>Terms of Service</span> </a> and <a target="_blank" href="https://productlogz.com/terms"><span>Privacy Policy</span> </a> </p>
                            </Form>
                        )
                    }

                    {
                        show_guest_post && (
                            <>
                                <div style={{ display: 'grid', gridTemplateColumns: '40% 1fr 40%', textAlign: 'center', alignItems: 'center' }}>
                                    <hr style={{ display: 'inline-block', color: '#888' }} /> Or <hr style={{ display: 'inline-block', color: '#888' }} />
                                </div>
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <Button onClick={() => guestUserHandler(callbackId)} color="primary" outline className="guest-btn">
                                        <FontAwesomeIcon
                                            icon={faUser}
                                        />
                                        <span className="auth-text">
                                            Continue as a guest
                                        </span>
                                    </Button>
                                </div>
                            </>
                        )
                    }

                    {
                        payloadValid.show && (
                            <Toaster
                                color={payloadValid.type} style={{ marginTop: '10px', paddingTop: '12px', paddingBottom: '12px' }}
                                alertText={payloadValid.text}
                            />
                        )
                    }

                    {
                        type === 'overview' && (
                            <p style={{ fontSize: '12px', marginBottom: '4px' }}>
                                {overviewType === 'signup' ? 'Register' : 'Login'} now to share your thoughts and participate in voting.
                            </p>
                        )
                    }

                    {/* ---- footer ---- */}
                    {
                        (type === 'signup' || (type === 'overview' && overviewType === 'signup')) && (
                            <p style={{ fontSize: '12px', marginBottom: '0' }}>
                                Already have an account? &nbsp;
                                <span style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => openOverviewModal('login')}>
                                    Login instead</span>
                            </p>
                        )
                    }

                    {
                        (type === 'login' || (type === 'overview' && overviewType === 'login')) && (
                            <p style={{ fontSize: '12px', marginBottom: '0' }}>
                                Not a member yet? &nbsp;
                                <span
                                    style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => openOverviewModal('signup')}>
                                    Create an account</span>
                            </p>
                        )
                    }

                </ModalBody>
                {
                    type !== 'overview' && (
                        <ModalFooter>
                            <Button color="primary" onClick={() => submitAuthManual()}>
                                Save
                            </Button>{' '}

                            <Button color="secondary" onClick={authModalToggle}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    )
                }
            </Modal>
        </>
    );
};

export default AuthModal;
